import React from 'react';
import { CheckCircle } from 'lucide-react';
import { aboutUs, team } from '../data/mock';

const ChiSiamo = () => {
  return (
    <div className="chi-siamo-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="display-title">Chi <span className="text-brand-red">Siamo</span></h1>
          <div className="accent-line"></div>
          <p className="body-large text-secondary" style={{ maxWidth: '800px', marginTop: '1.5rem' }}>
            Un'azienda specializzata in segnaletica stradale e generale, con esperienza consolidata e servizi completi
          </p>
        </div>
      </section>

      {/* Storia */}
      <section className="section">
        <div className="container">
          <div className="content-layout">
            <div className="content-text">
              <h2 className="section-title">La Nostra Storia</h2>
              <div className="accent-line"></div>
              <p className="body-large" style={{ marginTop: '1.5rem', lineHeight: '1.8' }}>
                {aboutUs.history}
              </p>
            </div>
            <div className="content-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_company-portal-91/artifacts/3ubj034q_dad04d98-4b54-46a6-a5cb-15fcc6bf2d3e%20-%20Copia.jpg"
                alt="Storia aziendale"
                className="image-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="section section-blue-tint">
        <div className="container">
          <div className="mission-vision-grid">
            <div className="mission-card card">
              <h2 className="subsection-title">Mission</h2>
              <div className="accent-line"></div>
              <p className="body-regular text-secondary" style={{ marginTop: '1.5rem', lineHeight: '1.8' }}>
                {aboutUs.mission}
              </p>
            </div>
            <div className="vision-card card">
              <h2 className="subsection-title">Vision</h2>
              <div className="accent-line"></div>
              <p className="body-regular text-secondary" style={{ marginTop: '1.5rem', lineHeight: '1.8' }}>
                {aboutUs.vision}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Valori */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">I Nostri Valori</h2>
            <div className="accent-line"></div>
          </div>

          <div className="values-grid">
            {aboutUs.values.map((value, idx) => (
              <div key={idx} className="value-card">
                <CheckCircle className="value-icon" size={32} />
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Il Nostro Team</h2>
            <div className="accent-line"></div>
            <p className="body-large text-secondary" style={{ marginTop: '1rem' }}>
              Professionisti con esperienza pluriennale nel settore
            </p>
          </div>

          <div className="team-grid">
            {team.map((member) => (
              <div key={member.id} className="team-card card">
                <div className="team-card-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="team-card-content">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <a href={`tel:${member.phone}`} className="team-phone">
                    {member.phone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style jsx>{`
        .chi-siamo-page {
          padding-top: 80px;
        }

        .page-hero {
          padding: var(--space-xl) 0 var(--space-lg);
          background: var(--bg-page);
        }

        .section-header {
          text-align: center;
          margin-bottom: var(--space-lg);
        }

        /* Content Layout */
        .content-layout {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: var(--space-lg);
          align-items: center;
        }

        @media (max-width: 1024px) {
          .content-layout {
            grid-template-columns: 1fr;
            gap: var(--space-md);
          }
        }

        .content-text {
          padding: var(--space-md);
        }

        .content-image {
          position: relative;
          height: 500px;
          overflow: hidden;
          border-radius: 0.5rem;
        }

        @media (max-width: 768px) {
          .content-image {
            height: 300px;
          }
        }

        .image-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* Mission & Vision */
        .mission-vision-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: var(--space-md);
        }

        @media (max-width: 768px) {
          .mission-vision-grid {
            grid-template-columns: 1fr;
          }
        }

        .mission-card,
        .vision-card {
          padding: var(--space-lg);
        }

        /* Values */
        .values-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-md);
          margin-top: var(--space-lg);
        }

        @media (max-width: 1024px) {
          .values-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .values-grid {
            grid-template-columns: 1fr;
          }
        }

        .value-card {
          background: var(--bg-card);
          border: 1px solid var(--border-light);
          padding: var(--space-md);
          transition: all 0.3s ease;
        }

        .value-card:hover {
          border-color: var(--brand-orange);
          transform: translateY(-4px);
        }

        .value-icon {
          color: var(--brand-orange);
          margin-bottom: 1.5rem;
        }

        .value-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 1rem;
        }

        .value-description {
          color: var(--text-secondary);
          line-height: 1.6;
        }

        /* Team */
        .team-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: var(--space-md);
          margin-top: var(--space-lg);
        }

        @media (max-width: 1024px) {
          .team-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .team-grid {
            grid-template-columns: 1fr;
          }
        }

        .team-card {
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        .team-card-image {
          width: 100%;
          height: 280px;
          overflow: hidden;
          background: var(--bg-card-hover);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .team-card-image img {
          width: 120px;
          height: 120px;
          object-fit: contain;
        }

        .team-card-content {
          padding: var(--space-md);
          text-align: center;
        }

        .team-name {
          font-size: 1.25rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 0.5rem;
        }

        .team-role {
          color: var(--brand-orange);
          font-size: 0.95rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          margin-bottom: 1rem;
        }

        .team-phone {
          color: var(--text-secondary);
          text-decoration: none;
          font-size: 0.95rem;
          transition: color 0.3s ease;
          display: inline-block;
        }

        .team-phone:hover {
          color: var(--brand-orange);
        }
      `}</style>
    </div>
  );
};

export default ChiSiamo;
